/**
 * Read More button used on Single Event page
 */

const ReadMore = ($) => {
	// text to display based on locale

	const readMoreText = window.location.href.includes("/fr/")
		? `Lire la suite +`
		: `Read more +`;
	const readLessText = window.location.href.includes(`/fr/`)
		? `Réduire -`
		: `Read less -`;

	// paragraphs in event content description
	const children = $("#js-event-description").children().not("button");

	// all paragraphs after first 1
	const hiddenParagraphs = children.slice(1);

	// read more button, hidden by default
	const readMoreButton = $("#read-more-button");

	// hide paragraphs on page load, show button
	if (children.length > 1) {
		hiddenParagraphs.hide();
		readMoreButton.show();
	}

	$("#read-more-button").on("click", function () {
		// toggle paragraphs
		if($(hiddenParagraphs).is(":visible")) {
			hiddenParagraphs.slideUp()
			$(this).text(readMoreText);
		} else {
			hiddenParagraphs.slideDown()
			$(this).text(readLessText);
		}

	});
};

export default ReadMore;
